module.exports = __webpack_public_path__ + "img/073676.4bffdace.png";